import React, { useEffect, useState } from "react";
import axios from "axios";

const STATUS_COLORS = {
  "Account Created": "bg-blue-500",
  "Event Registered": "bg-yellow-500",
  "Event Payment Done": "bg-green-500",
};

const LeadStatusSummary = () => {
  var JSToken;
  var accessToken;
  if (localStorage.user) {
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${window.$domain}/api/method/get_lead_status_counts`, config)
      .then((res) => {
        const resData = res.data.message;
        setData(resData.data || []);
        setTotal(resData.total || 0);
      })
      .catch((err) => console.error("Failed to load status data", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-5xl mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
        Total Leads by Status
      </h2>

      {loading ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : (
        <>
          {/* Status Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {data.map(({ lead_status, count }) => (
              <div
                key={lead_status}
                className={`p-4 rounded-lg text-white shadow-md ${
                  STATUS_COLORS[lead_status] || "bg-gray-400"
                }`}
              >
                <p className="text-sm font-medium">{lead_status}</p>
                <p className="text-2xl font-bold">{count}</p>
              </div>
            ))}
          </div>

          {/* Stacked Bar Chart */}
          <div className="h-6 w-full bg-gray-200 rounded-full flex overflow-hidden">
            {data.map(({ lead_status, count }) => {
              const width = total ? (count / total) * 100 : 0;
              return (
                <div
                  key={lead_status}
                  className={`${
                    STATUS_COLORS[lead_status] || "bg-gray-400"
                  } h-full`}
                  style={{ width: `${width}%` }}
                  title={`${lead_status}: ${count}`}
                ></div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default LeadStatusSummary;
